<template>
  <StudentAttendanceReport />
</template>

<script>
import StudentAttendanceReport from "@/components/StudentAttendanceReport.vue";

export default {
  name: "faltas-e-presencas",
  components: { StudentAttendanceReport },
};
</script>
